<template>
  <div
    :class="[
      { 'as-statistic-home': isHomePage },
      { 'as-tab-btn-center': isTabCenter },
      `as-parent-statics as-parent-statics-${siteName}`,
    ]"
  >
    <div v-if="isShowTab"
      class="as-nav-tabs-btn as-nav-tabs-btn__border"
      :class="`as-nav-tabs-btn-${siteName}`"
    >
      <div
        v-for="tab in statistics"
        :key="tab.id"
        class="as-nav-item"
        :class="{ active: activeTab === tab.type }"
        @click="activeTab = tab.type"
      >
        <span class="as-extra-item"></span>
        {{ getTabLabel(tab.type) }}
      </div>
    </div>
    <div v-else>
      <StatisticsItem
        :statistics="dataDefault"
        :match="match"
        :isHomePage="isHomePage"
        :isDefault="true"
      />
    </div>
    <!-- <NoData v-else /> -->

    <div v-if="isShowTab" class="as-tab-content">
      <StatisticsItem
        v-for="statistic in statistics"
        :key="statistic.id"
        v-show="activeTab === statistic.type"
        :statistics="statistic"
        :match="match"
        :isHomePage="isHomePage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces";
// import { useRoute } from "vue-router";
import StatisticsItem from "~src/components/statistics/StatisticsItem.vue";
import NoData from "~src/components/NoData.vue";
import { getProcessedStats, initializeData } from "~src/helpers";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
  isTabCenter?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
  isTabCenter: false,
});
console.log(props.statistics);

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref(0);

const dataDefault = {
  stats: [
    {
      team_id: props.match.home_team_id,
      ball_possession: 50,
      corner_kicks: 0,
      yellow_cards: 0,
      red_cards: 0,
      shots_on_target: 0,
      shots_off_target: 0,
      dangerous_attack: 0,
    },
    {
      team_id: props.match.away_team_id,
      ball_possession: 50,
      corner_kicks: 0,
      yellow_cards: 0,
      red_cards: 0,
      shots_on_target: 0,
      shots_off_target: 0,
      dangerous_attack: 0,
    },
  ],
  id: "default",
  type: 5,
};

const statisticAll = computed<IStatistics>(() => {
  return props.statistics.find(
    (item: IStatistics) => item.type === 0
  ) as IStatistics;
});

const isShowTab = computed(() => {
  if (!statisticAll.value) {
    return false;
  }

  const stats = getProcessedStats(props.match, statisticAll.value, false);
  return stats.length > 0;
});

const getTabLabel = (type: number): string => {
  switch (type) {
    case 0:
      return "Tất cả";
    case 1:
      return "Hiệp 1";
    case 2:
      return "Hiệp 2";
    case 3:
      return "Hiệp Phụ 1";
    case 4:
      return "Hiệp Phụ 2";
    default:
      return "Unknown";
  }
};
</script>

<script lang="ts">
export default {};
</script>
